import input from '../../../../input';

const light = (params) => input.borderColor.default.light(params);

export default light;
